import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UserDropdown from "../UserDropdown";

const Navbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 20) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
            <div className="nav-container">
                <div className="logo" onClick={() => navigate("/")} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <span className="logo-text" style={{ fontSize: '28px', fontWeight: '700', lineHeight: 1 }}>
                        <span className="logo-route" style={{ color: '#0F172A' }}>Route</span>
                        <span className="logo-chef" style={{ color: '#FF5B15' }}>chef</span>
                    </span>
                </div>
                <div className="navbar-right">
                    <UserDropdown />
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
